module.exports = __webpack_public_path__ + "static/media/amex.b35eadca.svg";